import React, { useImperativeHandle } from 'react';
import Select, { components } from 'react-select';
import { Image } from 'react-bootstrap';
import svgGrayDropdownIcon from '../../../../../../assets/images/svg-gray-dropdown-icon.svg'
import svgGrayCloseIcon from '../../../../../../assets/images/Action-Icons/Close-Icon.svg'
import '../sharedFormControl.css'

const SelectBox = (props, ref) => {

    useImperativeHandle(ref, () => ({ isValid }), [props.value]);

    const isValid = () => {

        if (props.required && props.value)
            return true;
        else if (props.required && !props.value)
            return false;

        return true;

    }

    const onChange = (val) => {


        if (props.onChange)
            props.onChange(props.objectKey, val?.value)


    }

    const Option = props => {
        return (
            <components.Option {...props}>
                <div>{props.data?.label ?? ''}</div>
                <div style={{ fontSize: 11 }}>{props.data?.subLabel ?? ''}</div>
            </components.Option>
        );
    };


    const customFilter = (option, searchText) => {

        let label = option?.label?.toString()
        let subLabel = option?.data?.subLabel?.toString()
        let customSearchText = searchText?.toString()

        if (typeof label === 'string' || typeof subLabel === 'string') {
            if (subLabel?.toLowerCase().includes(customSearchText?.toLowerCase()) || label?.toLowerCase().includes(customSearchText?.toLowerCase())) {
                return true;
            } else {
                return false;
            }
        }
    }


    return (
        <React.Fragment>
            <fieldset className={`cust-multi-select-box default-fieldset ${props.whiteColor ? 'select-white-bg' : ''}`}>
                {!props.hideLegend ? <legend className='default-fieldset-label'>{props.label ? props.label : ''}</legend> : null}
                <span className={`${props.disabled ? 'disabled-select-box-with-icon' : ''} select-box-with-icon`}>
                    <Select
                        isClearable={props.showClearable ? true : false}
                        isSearchable={true}
                        name={props.name}
                        placeholder={props.placeholder}
                        className="react-select-dealerlist"
                        options={props.options ? props.options : []}
                        value={props.value && Array.isArray(props.options)
                            ? props.options.filter(item => item.value === props.value)[0] : null}
                        onChange={option => onChange(option)}
                        isDisabled={props.disabled ? props.disabled : false}
                        menuPlacement='auto'
                        menuPosition={props.menuPosition ? 'fixed' : ''}
                        menuShouldBlockScroll={props.menuShouldBlockScroll ? 'fixed' : ''}
                        components={{ Option }}
                        filterOption={customFilter}
                    />
                    {props.value && props.showClearable ?
                        <span className='close-icon-clearable'>
                            <Image width={12} src={svgGrayCloseIcon} alt="dropdown-icon" /></span> : ''}
                    <Image className='dropdown-icon' src={svgGrayDropdownIcon} alt="dropdown-icon" />
                </span>
            </fieldset>
            {props.required && props.validated && !isValid() ? <span className="input-error-message">{props.errorMessage ? props.errorMessage : `Please select a valid ${props.name}.`}</span> : null}
        </React.Fragment>
    )

}

export default React.forwardRef(SelectBox);